

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const ALUMNIREGISTRATIONGETALL= createAsyncThunk(
  "AlumniRegistrationGetAll/AlumniRegistrationGetAll",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const AlumniRegistrationGetAllSlice = createSlice({
  name: "AlumniRegistrationGetAllSlice",
  initialState: {
    AlumniRegistrationGetAll: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfAlumniRegistrationGetAll: (state) => {
        state.AlumniRegistrationGetAll.loading = false
        state.AlumniRegistrationGetAll.error = false
        state.AlumniRegistrationGetAll.data = []
        state.AlumniRegistrationGetAll.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ALUMNIREGISTRATIONGETALL.fulfilled, (state, action) => {
      state.AlumniRegistrationGetAll = {
        ...state.AlumniRegistrationGetAll,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ALUMNIREGISTRATIONGETALL.pending, (state, action) => {
      state.AlumniRegistrationGetAll = {
        ...state.AlumniRegistrationGetAll,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ALUMNIREGISTRATIONGETALL.rejected, (state, action) => {
      state.AlumniRegistrationGetAll = {
        ...state.AlumniRegistrationGetAll,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const AlumniRegistrationGetAllAction = {
    ALUMNIREGISTRATIONGETALL,
};

export { AlumniRegistrationGetAllAction };
export default AlumniRegistrationGetAllSlice.reducer;
export const {setInitialStateOfAlumniRegistrationGetAll} = AlumniRegistrationGetAllSlice.actions
